class MobileSearchTrigger extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", this._handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._handleClick);
  }

  _handleClick(e) {
    const searchDiv = this.querySelector('[data-component="MobileSearchBar"]');
    const props = JSON.parse(searchDiv.getAttribute("data-props") || "{}");
    props.defaultOpen = true;
    searchDiv.setAttribute("data-props", JSON.stringify(props));
    this.querySelector(".header__action-item-link").style.display = "none";
    this.querySelector('[data-component="MobileSearchBar"] input')?.focus();
  }
}

customElements.define("mobile-search-trigger", MobileSearchTrigger);
